<template>
  <CBreadcrumb class="d-md-down-none me-auto mb-0">
    <CBreadcrumbItem
      v-for="item in breadcrumbs"
      :key="item"
      :href="item.active || item == breadcrumbs[breadcrumbs.length - 1] ? '' : item.path"
      :active="item.active"
    >
    {{ $t(item.name) }}
    </CBreadcrumbItem>
  </CBreadcrumb>
</template>

<script>
import { onMounted, ref } from 'vue'
import router from '@/app/router'

export default {
  name: 'AppBreadcrumb',
  setup() {
    const breadcrumbs = ref()

    const getBreadcrumbs = () => {
      return router.currentRoute.value.matched.map((route) => {

        const nameruta = route.name && route.name.includes(':') ? route.name.split(':')[1] : route.name;
        // Obtenemos el title del breadcrumb desde meta o fallback al name
        const breadcrumbTitle = route.meta?.breadcrumb?.title || nameruta;
        return {
          active: route.path === router.currentRoute.value.fullPath,
          name: breadcrumbTitle,  // Aquí usamos el title que ya tiene la clave de traducción
          //name: route.name && route.name.includes(':') ? route.name.split(':')[1] : route.name,
          path: `${router.options.history.base}${route.path}`,
        }
      }).filter(item => item.name);
    }

    router.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    return {
      breadcrumbs,
    }
  },
  computed: {
  }
}
</script>
